<template>
  <div class="content">
    <s-location v-if="/apply/.test($route.path)" apply title="신청내역 확인"/>
    <s-location v-else mypage title="신청내역 확인"/>

    <c오사용증표_입금영수증 ref="dialog_receipt"/>

     <div class="btn_group mt0">
      <div class="right">
        <button @click="initData" class="btn icon reload">초기화</button>
        <button @click="doSearch" class="btn icon search_black">검색</button>
      </div>
    </div>

    <table class="tbl01 sch_tbl">
      <tr>
        <th>신청일</th>
        <td>
          <i-input-date input-class="w_inputno" title="시작일" v-model="search.iv_viastatdtfr" :placeholder="search.iv_viastatdtfr"/>
        ~ <i-input-date input-class="w_inputno" title="종료일" v-model="search.iv_viastatdtto" :placeholder="search.iv_viastatdtto"/>
        <br class="mobile"/>
          <s-date-range :fr.sync="search.iv_viastatdtfr" :to.sync="search.iv_viastatdtto" />
        </td>
      </tr>
      <tr>
        <th>신청구분</th>
        <td>
            <div class="lvl_ml">
              <label><input type="checkbox" v-model="view_all"       :true-value="true" :false-value="false" @change="onchange_view_all" /> 전체</label>
              <label><input type="checkbox" v-model="view.VIAFREE"   :true-value="true" :false-value="false"/> 면제증표      <template v-if="list_VIAFREE.totalCount" > ({{  list_VIAFREE.totalCount }}) </template>  </label>
              <label><input type="checkbox" v-model="view.CH_OFFICE" :true-value="true" :false-value="false"/> 면제증표(소속변경)  <template v-if="list_CH_OFFICE.totalCount" > ({{  list_CH_OFFICE.totalCount }}) </template>  </label>
              <label><input type="checkbox" v-model="view.BOKDARI"   :true-value="true" :false-value="false"/> 면제증표(복대리)  <template v-if="list_BOKDARI.totalCount" > ({{  list_BOKDARI.totalCount }}) </template>  </label>
              <label><input type="checkbox" v-model="view.CH_OWNER"  :true-value="true" :false-value="false"/> 미사용 증표 전환    <template v-if="list_CH_OWNER.totalCount" > ({{  list_CH_OWNER.totalCount }}) </template>  </label>
              <label><input type="checkbox" v-model="view.REFUND"    :true-value="true" :false-value="false"/> 미사용 증표 환불    <template v-if="list_REFUND.totalCount" > ({{  list_REFUND.totalCount }}) </template>  </label>
              <br/>
              <label><input type="checkbox" v-model="view.BUY_REFUND" :true-value="true" :false-value="false"/> 과오납 환불 신청 내역<template v-if="list_BUY_REFUND.totalCount" > ({{  list_BUY_REFUND.totalCount }}) </template>  </label>
              <label><input type="checkbox" v-model="view.CH_CASE"   :true-value="true" :false-value="false"/> 오사용 증표 정정    <template v-if="list_CH_CASE.totalCount" > ({{  list_CH_CASE.totalCount }}) </template>  </label><br/>
            </div>
        </td>
      </tr>
    </table>

    <!-- 면제증표(일반) 신청 내역 -->
    <template v-if="view.VIAFREE">
      <h4 class="sub_title02">면제증표(일반) 신청 내역</h4>
      <div class="scroll_wrap"> <!--모바일 스크롤 -->
        <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

        <table class="tbl01 thin">
          <thead>
            <tr>
              <th class="no">순번</th>
              <th>신청일자</th>
              <th>신청인</th>
              <th>면제사건<br/>종류</th>
              <th>발행된 증표번호</th>
              <th>관할기관</th>
              <th>사건번호</th>
              <th class="vianame">위임인</th>
              <th class="vianame">상대방</th>
              <th class="td_org01">상태</th>
              <th class="td_org01">수정</th>
            </tr>
          </thead>
          <tr v-for="(item,i) in list_VIAFREE.items.slice(list_VIAFREE.listSize * (list_VIAFREE.pageNo - 1), list_VIAFREE.listSize * list_VIAFREE.pageNo)" :key=i>
            <td class="td_gray01">{{ list_VIAFREE.items.length - ((list_VIAFREE.pageNo -1) * list_VIAFREE.listSize)- i }}</td>
            <td class="td_gray01">{{ item.viastatdt | moment('YYYY.MM.DD.') }}</td>
            <td class="td_gray01">{{ item.membnm }}</td>
            <td class="td_gray01">
              {{ item.freeclsfnm }}
              <span v-if="item.freeclsf == 'B10960'"> / {{ item.freeclsf_etc }}</span>
            </td>
            <td class="td_gray01">{{ item.rcptno | rcptno }}</td>
            <td class="td_gray01">{{ item.isttoutplac }}</td>
            <td class="td_gray01">{{ item.caseno }}</td>
            <td class="td_gray01">{{ item.client }}</td>
            <td class="td_gray01">{{ item.otherside }}</td>
            <td>
              {{ item.approveclsfnm }}
              <span id="id_msg">
              <em class="icon_info"  v-if="item.approveclsfnm == '반려'">i</em>
                <div class="toggleInfo">
                  <p class="tit">반려사유</p>
                  <div class="cont">{{ item.approvemsg}}</div>
                </div>
              </span>
            </td>
            <td><button class="btn xxs org01 outline" @click="callDialogViaUse(item)">수정/인쇄</button></td>
          </tr>
        </table>
      </div> <!--// scroll_wrap -->
      <div v-if="list_VIAFREE.items.length > 10" class="paging"> <p class="num"> <s-page :pageNo.sync="list_VIAFREE.pageNo" :totalCount="list_VIAFREE.totalCount" :listSize="list_VIAFREE.listSize"/> </p> </div>
    </template>
    <!-- //면제증표(일반) 신청 내역 -->

    <!-- 면제증표(소속변경) 신청 내역 -->
    <template v-if="view.CH_OFFICE">
      <h4 class="sub_title02 mt10">면제증표(소속변경) 신청 내역</h4>

      <div class="scroll_wrap"> <!--모바일 스크롤 -->
        <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>
        <table class="tbl01 thin">
          <thead>
            <tr>
              <th class="no">순번</th>
              <th>신청일자</th>
              <th class="viakind">증표종류</th>
              <th>증표번호</th>
              <th>발행된 증표번호</th>
              <th>관할기관</th>
              <th class="vianame">위임인</th>
              <th class="vianame">상대방</th>
              <th class="td_org01">변경 전<br/>소속</th>
              <th class="td_org01">변경 후<br/>소속</th>
              <th class="td_org01">상태</th>
              <th class="td_org01">수정</th>
            </tr>
          </thead>
          <tr v-for="(item,i) in list_CH_OFFICE.items.slice(list_CH_OFFICE.listSize * (list_CH_OFFICE.pageNo - 1), list_CH_OFFICE.listSize * list_CH_OFFICE.pageNo)" :key=i>
            <td class="td_gray01">{{ list_CH_OFFICE.items.length - ((list_CH_OFFICE.pageNo -1) * list_CH_OFFICE.listSize)- i }}</td>
            <td class="td_gray01">{{ item.viastatdt | moment('YYYY.MM.DD.') }}</td>
            <td class="td_gray01">{{ item.caseclsfnm }}</td>
            <td class="td_gray01">{{ item.rcptno | insertHyphen(5) }}</td>
            <td class="td_gray01">{{ item.new_rcptno | insertHyphen(5) }}</td>
            <td class="td_gray01">{{ item.isttoutplac }}</td>
            <td class="td_gray01">{{ item.client }}</td>
            <td class="td_gray01">{{ item.otherside }}</td>
            <td>{{ item.org_membnm }}</td>
            <td>{{ item.to_membnm }}</td>
            <td>
              {{ item.approveclsfnm }}
              <span id="id_msg">

                <em class="icon_info"  v-if="item.approveclsfnm == '반려'">i
                  <div class="toggleInfo">
                    <p class="tit">반려사유</p>
                    <div class="cont">{{ item.approvemsg}}</div>
                  </div>
                </em>
              </span>
            </td>
            <td><button class="btn xxs org01 outline" @click="callDialogViaUse(item)">수정/인쇄</button></td>
          </tr>
        </table>
      </div> <!--// scroll_wrap -->
      <div v-if="list_CH_OFFICE.items.length > 10" class="paging"> <p class="num"> <s-page :pageNo.sync="list_CH_OFFICE.pageNo" :totalCount="list_CH_OFFICE.totalCount" :listSize="list_CH_OFFICE.listSize"/> </p> </div>
    </template>
    <!-- //면제증표(소속변경) 신청 내역 -->

    <!-- 복대리 신청 내역 -->
    <template v-if="view.BOKDARI">
      <h4 class="sub_title02">면제증표(복대리) 신청 내역</h4>

      <div class="scroll_wrap"> <!--모바일 스크롤 -->
        <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>
        <table class="tbl01 thin">
          <thead>
            <tr>
              <th class="no">순번</th>
              <th>신청일자</th>
              <th class="viakind">증표종류</th>
              <th>증표번호</th>
              <th>발행된 증표번호</th>
              <th>관할기관</th>
              <th class="vianame">위임인</th>
              <th class="vianame">상대방</th>
              <th class="td_org01">본대리인</th>
              <th class="td_org01">복대리인</th>
              <th class="td_org01">상태</th>
              <th class="td_org01">수정</th>
            </tr>
          </thead>
          <tr v-for="(item,i) in list_BOKDARI.items.slice(list_BOKDARI.listSize * (list_BOKDARI.pageNo - 1), list_BOKDARI.listSize * list_BOKDARI.pageNo)" :key=i>
            <td class="td_gray01">{{ list_BOKDARI.items.length - ((list_BOKDARI.pageNo -1) * list_BOKDARI.listSize)- i }}</td>
            <td class="td_gray01">{{ item.viastatdt | moment('YYYY.MM.DD.') }}</td>
            <td class="td_gray01">{{ item.caseclsfnm }}</td>
            <td class="td_gray01">{{ item.rcptno | insertHyphen(5) }}</td>
            <td class="td_gray01">{{ item.new_rcptno | insertHyphen(5) }}</td>
            <td class="td_gray01">{{ item.isttoutplac }}</td>
            <td class="td_gray01">{{ item.client }}</td>
            <td class="td_gray01">{{ item.otherside }}</td>
            <td>{{ item.org_membnm }}</td>
            <td>{{ item.to_membnm }}</td>
            <td>
              {{ item.approveclsfnm }}
              <span id="id_msg">
                <em class="icon_info"  v-if="item.approveclsfnm == '반려'">i
                  <div class="toggleInfo">
                    <p class="tit">반려사유</p>
                    <div class="cont">{{ item.approvemsg}}</div>
                  </div>
                </em>
              </span>
            </td>
            <td><button class="btn xxs org01 outline" @click="callDialogViaUse(item)">수정/인쇄</button></td>
          </tr>
        </table>
      </div> <!--// scroll_wrap -->
      <div v-if="list_BOKDARI.items.length > 10" class="paging"> <p class="num"> <s-page :pageNo.sync="list_BOKDARI.pageNo" :totalCount="list_BOKDARI.totalCount" :listSize="list_BOKDARI.listSize"/> </p> </div>
    </template>
    <!-- //면제증표(소속변경) 신청 내역 -->

    <!-- 미사용 증표 전환 신청(명의변경) 내역 -->
    <template v-if="view.CH_OWNER">
      <h4 class="sub_title02 m_ls-1">미사용 증표 전환 신청(명의변경) 내역</h4>
      <div class="scroll_wrap"> <!--모바일 스크롤 -->
        <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

        <table class="tbl01 thin">
          <thead>
            <tr>
              <th class="no">순번</th>
              <th>신청일자</th>
              <th>신청인</th>
              <th width="50px;">증표종류</th>
              <th>증표번호</th>
              <th class="td_org01">인수받을<br/>회원명</th>
              <th class="td_org01">전환사유</th>
              <th class="td_org01">상태</th>
            </tr>
          </thead>

          <tr v-for="(item,i) in list_CH_OWNER.items.slice(list_CH_OWNER.listSize * (list_CH_OWNER.pageNo - 1), list_CH_OWNER.listSize * list_CH_OWNER.pageNo)" :key=i>
            <td class="td_gray01">{{ list_CH_OWNER.items.length - ((list_CH_OWNER.pageNo -1) * list_CH_OWNER.listSize)- i }}</td>
            <td class="td_gray01">{{ item.viastatdt | moment('YYYY.MM.DD.') }}</td>
            <td class="td_gray01">{{ item.membnm }}</td>
            <td class="td_gray01">{{ item.caseclsfnm }}</td>
            <td class="td_gray01">{{ item.rcptno | insertHyphen(5) }}</td>
            <td>
              {{ item.to_membnm }} ({{ item.to_membno }})
              <div v-if="item.to_membofficenm">({{ item.to_membofficenm }})</div>
            </td>
            <td>{{ item.reasonclsfnm }}</td><!-- 전환사유 -->
            <td>
              {{ item.approveclsfnm }}
              <span id="id_msg">

                <em class="icon_info"  v-if="item.approveclsfnm == '반려'">i
                  <div class="toggleInfo">
                    <p class="tit">반려사유</p>
                    <div class="cont">{{ item.approvemsg}}</div>
                  </div>
                </em>
              </span>
            </td>
          </tr>
        </table>

        <div v-if="list_CH_OWNER.items.length > 10" class="paging"> <p class="num"> <s-page :pageNo.sync="list_CH_OWNER.pageNo" :totalCount="list_CH_OWNER.totalCount" :listSize="list_CH_OWNER.listSize"/> </p> </div>

      </div> <!--// scroll_wrap -->
    </template>
    <!-- //미사용 증표 전환 신청(명의변경) 내역 -->

    <!-- 미사용 증표 환불 신청 내역 -->
    <template v-if="view.REFUND">

      <h4 class="sub_title02">미사용 증표 환불 신청 내역</h4>
      <span class="red01">※ 접수일로부터 2주 이내에 요청하신 계좌로 환불처리 됩니다.</span>

      <div class="scroll_wrap"> <!--모바일 스크롤 -->
        <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

        <table class="tbl01 thin">
          <thead>
            <tr>
              <th class="no">순번</th>
              <th>신청일자</th>
              <th>신청인</th>
              <th>합계</th>
              <th class="td_org01">환불사유</th>
              <th class="td_org01">환불계좌번호</th>
              <th class="td_org01">은행명</th>
              <th class="td_org01">예금주</th>
              <th class="td_org01">상태</th>
              <th class="td_org01" width="67">상세보기</th>
            </tr>
          </thead>

          <tr v-for="(item,i) in list_REFUND.items.slice(list_REFUND.listSize * (list_REFUND.pageNo - 1), list_REFUND.listSize * list_REFUND.pageNo)" :key=i>
            <td class="td_gray01">{{ list_REFUND.items.length - ((list_REFUND.pageNo -1) * list_REFUND.listSize)- i }}</td>
            <td class="td_gray01">{{ item.viastatdt | moment('YYYY.MM.DD.') }}</td>
            <td class="td_gray01">{{ item.membnm }}</td>
            <td>{{ item.rf_amt | comma }}</td>
            <td>{{ item.rrefund_reasonclsfnm }}</td>
            <td>{{ item.rfaccno }}</td>
            <td>{{ item.rfbankcodenm }}</td>
            <td>{{ item.rfaccname }}</td>
            <td>
              {{ item.group_approveclsfnm }}
              <span id="id_msg">
                <em class="icon_info"  v-if="item.group_approveclsfnm == '반려'">i
                  <div class="toggleInfo">
                    <p class="tit">반려사유</p>
                    <div class="cont">{{ item.group_approvemsg}}</div>
                  </div>
                </em>
              </span>
            </td>
            <td><button @click="showRefundDetail(item, i)" class="btn xs">상세보기</button></td>
          </tr>
        </table>
        <div v-if="list_REFUND.items.length > 10" class="paging"> <p class="num"> <s-page :pageNo.sync="list_REFUND.pageNo" :totalCount="list_REFUND.totalCount" :listSize="list_REFUND.listSize"/> </p> </div>

        <div v-if="refundDetailShowYn" >
          <h4 class="sub_title02">미사용 증표 환불 신청 상세 내역</h4>

          <table class="tbl01 thin">
            <thead>
              <tr>
                <th class="no">순번</th>
                <th>신청일자</th>
                <th>신청인</th>
                <th width="50px;">증표종류</th>
                <th>증표번호</th>
                <th>증표금액</th>
                <th class="td_org01">환불사유</th>
                <th class="td_org01">환불계좌번호</th>
                <th class="td_org01">은행명</th>
                <th class="td_org01">예금주</th>
                <th class="td_org01">접수일</th>
              </tr>
            </thead>

            <tr v-for="(item,i) in list_REFUND_DETAIL.items" :key=i>
              <td class="td_gray01">{{ i +1 }}</td>
              <td class="td_gray01">{{ item.viastatdt | moment('YYYY.MM.DD.') }}</td>
              <td class="td_gray01">{{ item.membnm }}</td>
              <td class="td_gray01">{{ item.caseclsfnm }}</td>
              <td class="td_gray01">{{ item.rcptno | insertHyphen(5) }}</td>
              <td>{{ item.viafee | comma }}</td>
              <td>{{ item.reasonclsfnm }}</td>
              <td>{{ item.rfaccno }}</td>
              <td>{{ item.rfbankcodenm }}</td>
              <td>{{ item.rfaccname }}</td>
              <td>{{ item.group_approvedt | moment('YYYY.MM.DD.') }}</td>
            </tr>
          </table>
        </div>
      </div> <!--// scroll_wrap -->
    </template>
    <!-- // 미사용 증표 환불 신청 내역 -->

    <!-- 과오납 환불 신청 내역 -->
    <template v-if="view.BUY_REFUND">
        <h4 class="sub_title02 " > 과오납 환불 신청 내역</h4>
        <span class="red01">※ 접수일로부터 2주 이내에 요청하신 계좌로 환불처리 됩니다. </span>

      <div class="scroll_wrap"> <!--모바일 스크롤 -->
        <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

        <table class="tbl01 thin">
          <thead>
            <tr>
              <th class="no">순번</th>
              <th>신청일자</th>
              <th>환불구분</th>
              <th>은행</th>
              <th>계좌번호    </th>
              <th>예금주      </th>
              <th>금액        </th>
              <th>환불상태    </th>
              <th>비고        </th>
              <th>환불접수일자</th>
            </tr>
          </thead>
          <tr v-for="(item,i) in list_BUY_REFUND.items.slice(list_BUY_REFUND.listSize * (list_BUY_REFUND.pageNo - 1), list_BUY_REFUND.listSize * list_BUY_REFUND.pageNo)" :key=i>
            <td class="td_gray01">{{ list_BUY_REFUND.items.length - ((list_BUY_REFUND.pageNo -1) * list_BUY_REFUND.listSize)- i }}</td>
            <td class="td_gray01">{{ item.refunddt | moment("YYYY.MM.DD.")}}</td>
            <td class="td_gray01">{{ item.refundclsfnm }}</td>
            <td class="td_gray01">{{ item.rfbankcodenm }}</td>
            <td class="td_gray01">{{ item.rfaccno }}</td>
            <td class="td_gray01">{{ item.rfaccname }}</td>
            <td class="td_gray01">{{ item.rf_amt | comma }}</td>
            <td class="td_gray01">{{ item.rfstatnm }}</td>
            <td class="td_gray01">{{ item.approvemsg }}</td>
            <td class="td_gray01">{{ item.rfokdt | moment("YYYY.MM.DD.")}}</td>
          </tr>
        </table>

        </div>
        <div v-if="list_BUY_REFUND.items.length > 10" class="paging"> <p class="num"> <s-page :pageNo.sync="list_BUY_REFUND.pageNo" :totalCount="list_BUY_REFUND.totalCount" :listSize="list_BUY_REFUND.listSize"/> </p> </div>
      </template>
    <!-- // 과오납 환불 신청 내역 -->

    <!-- 오사용 증표 정정 신청 내역 -->
    <template v-if="view.CH_CASE">
      <h4 class="sub_title02">오사용 증표 정정 신청 내역</h4>
      <div class="scroll_wrap"> <!--모바일 스크롤 -->
        <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

        <table class="tbl01 thin">
          <thead>
            <tr>
              <th class="no">순번</th>
              <th>신청일자</th>
              <th>신청인</th>
              <th>증표번호</th>

              <th class="viakind">변경 전<br/>증표종류</th>
              <th class="viakind">변경 전<br/>증표금액</th>
              <th class="viakind">변경 후<br/>증표종류</th>
              <th class="viakind">변경 후<br/>증표금액</th>

              <th class="td_org01">차액</th>
              <th class="td_org01">정정사유</th>
              <th class="td_org01">환불/입금<br/>계좌번호</th>
              <th class="td_org01">은행명</th>
              <th class="td_org01">예금주</th>
              <th class="td_org01">상태</th>
            </tr>
          </thead>

          <tr v-for="(item,i) in list_CH_CASE.items.slice(list_CH_CASE.listSize * (list_CH_CASE.pageNo - 1), list_CH_CASE.listSize * list_CH_CASE.pageNo)" :key=i>
            <td class="td_gray01">{{ list_CH_CASE.items.length - ((list_CH_CASE.pageNo -1) * list_CH_CASE.listSize)- i }}</td>
            <td class="td_gray01">{{ item.viastatdt | moment('YYYY.MM.DD.') }}</td>
            <td class="td_gray01">{{ item.membnm }}</td>
            <td class="td_gray01">{{ item.rcptno | insertHyphen(5) }}</td>

            <td class="td_gray01">{{ item.org_caseclsf }}</td>
            <td class="td_gray01">{{ item.org_viafee | comma }}</td>
            <td class="td_gray01">{{ item.to_caseclsfnm }}</td>
            <td class="td_gray01">{{ item.to_viafee | comma }}</td>

            <td class="td_gray01">
              {{ item.diff_amt | absComma }}
              <span v-if="item.diff_amt > 0">(입금금액)</span>
              <span v-if="item.diff_amt < 0">(환불금액)</span>
            </td>
            <td class="td_gray01">{{ item.reasonclsfnm }}</td>
            <td class="td_gray01">
              <span v-if="item.diff_amt > 0">{{ T.codeText(code.CONFIG, '모계좌') }}</span>
              <span v-if="item.diff_amt < 0">{{ item.rfaccno }}</span>
            </td>
            <td class="td_gray01">{{ item.rfbankcodenm }}</td>
            <td class="td_gray01">{{ item.rfaccname }}</td>
            <td>
              {{ item.approveclsfnm }}
              <span id="id_msg">

              <em class="icon_info"  v-if="item.approveclsfnm == '반려'">i</em>
                <div class="toggleInfo">
                  <p class="tit">반려사유</p>
                  <div class="cont">{{ item.approvemsg}}</div>
                </div>
              </span>





              <button v-if="item.diff_amt > 0 && item.approveclsfnm == '승인'" class="btn xs org01 outline" @click="callDialog_오사용증표_영수증(item)">영수증</button>
            </td>
            <!-- 회원이 추가입금 하는상황 & [승인] 상태 : [영수증 출력] 표시 -->
          </tr>
        </table>
        <div v-if="list_CH_CASE.items.length > 10" class="paging"> <p class="num"> <s-page :pageNo.sync="list_CH_CASE.pageNo" :totalCount="list_CH_CASE.totalCount" :listSize="list_CH_CASE.listSize"/> </p> </div>
      </div> <!--// scroll_wrap -->
    </template>
    <!-- // 오사용 증표 정정 신청 내역 -->


    <!-- 오프라인 증표 정정 신청
    <h4 class="sub_title02">오프라인 증표 교환 신청</h4>
    <div class="scroll_wrap">
      <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

      <table class="tbl01 thin">
        <thead>
          <tr>
            <th class="no">순번</th>
            <th>구입일자</th>
            <th width="50px;">증표종류</th>
            <th>증표번호</th>
            <th>
              경유
              <br />일자
            </th>
            <th>관할기관</th>
            <th>사건명</th>
            <th class="vianame">위임인</th>
            <th class="vianame">상대방</th>
            <th class="td_org01 line_l">수임일자</th>
            <th class="td_org01" width="40px">
              사건
              <br />유형
            </th>
            <th class="td_org01">사건번호</th>
            <th class="td_org01 vianame">담당변호사</th>
            <th class="td_org01 btn01">비고</th>
            <th class="td_org01">상태</th>
          </tr>
        </thead>

        <tr v-for="(item,i) in list_CH_ONLINE.items.slice(list_CH_ONLINE.listSize * (list_CH_ONLINE.pageNo - 1), list_CH_ONLINE.listSize * list_CH_ONLINE.pageNo)" :key=i>
          <td class="td_gray01">{{ i +1 }}</td>
          <td class="td_gray01">{{ item.selldt | moment('YYYY.MM.DD.') }}</td>
          <td class="td_gray01">{{ item.caseclsfnm }}</td>
          <td class="td_gray01">{{ item.rcptno | insertHyphen(5) }}</td>
          <td class="td_gray01">{{ item.viadt | moment('YYYY.MM.DD.') }}</td>
          <td class="td_gray01">{{ item.isttoutplac }}</td>
          <td class="td_gray01">{{ item.casenm }}</td>
          <td class="td_gray01">{{ item.client }}</td>
          <td class="td_gray01">{{ item.otherside }}</td>
          <td class="td_gray01">{{ item.cntchargdt | moment('YYYY.MM.DD.') }}</td>
          <td>{{ item.casetypenm }}</td>
          <td>{{ item.caseno }}</td>
          <td>{{ item.membnms }}</td>
          <td>{{ item.remk }}</td>
          <td>{{ item.approveclsfnm }}</td>
        </tr>
      </table>
    </div>
    <div v-if="list_CH_ONLINE.items.length > 10" class="paging"> <p class="num"> <s-page :pageNo.sync="list_CH_ONLINE.pageNo" :totalCount="list_CH_ONLINE.totalCount" :listSize="list_CH_ONLINE.listSize"/> </p> </div>
-->
  </div>
</template>

<script>
let ui
import ModalViaFormVue from '../../components/ModalViaForm.vue';
export default {
  components: {
    'c오사용증표_입금영수증'   : require('@/components/c오사용증표_입금영수증.vue').default,
  },
   data () {
    return {
      search : {},
      search_init : {
          iv_viastatdtfr : this.$moment().subtract(1, 'months').format("YYYY-MM-DD")
        , iv_viastatdtto : this.$moment().format("YYYY-MM-DD")
        , iv_viadtfr     : ''
        , iv_viadtto     : ''
        , iv_approveclsf : ''
        , iv_paystat     : ''
        , iv_rfstat      : ''
        , iv_viastatclsf : ''
        , iv_casetype    : ''
        , iv_client      : ''
        , iv_otherside   : ''
        , iv_pay_yn      : ''
      },
      view_all : true,
      view : {
        VIAFREE : true,
        CH_OFFICE : true,
        BOKDARI : true,
        CH_OWNER : true,
        REFUND : true,
        CH_CASE : true,
        BUY_REFUND : true,
      },
      code: {},
      chkAll : false,
      list              : { items: [], totalCount: 0, listSize : 10, pageNo : 1, },
      list_VIAFREE      : { items: [], totalCount: 0, listSize : 10, pageNo : 1, },
      list_CH_OFFICE    : { items: [], totalCount: 0, listSize : 10, pageNo : 1, },
      list_BOKDARI    : { items: [], totalCount: 0, listSize : 10, pageNo : 1, },
      list_CH_OWNER     : { items: [], totalCount: 0, listSize : 10, pageNo : 1, },
      list_REFUND       : { items: [], totalCount: 0, listSize : 10, pageNo : 1, },
      list_REFUND_DETAIL: { items: [], totalCount: 0, },
      list_CH_CASE      : { items: [], totalCount: 0, listSize : 10, pageNo : 1, },
      list_CH_ONLINE    : { items: [], totalCount: 0, listSize : 10, pageNo : 1, },
      list_BUY_REFUND   : { items: [], totalCount: 0, listSize : 10, pageNo : 1, },// 과오납 환불 입금내역

      refundDetailShowYn : false,
      refundDetailShowNum : '', // [상세보기] 누른 항목의 index 번호
      dayStr: ['일', '월', '화', '수', '목', '금', '토'],
      date: '2018-06-01',

      defaultPopperProps : {
        arrowPosition: 'start',
        arrowOffsetScaling: 1,
        popperOptions: {
          placement: 'bottom-start',
          positionFixed: true,
          // more options in https://popper.js.org
        },
      },
    }
  },
  watch : {
    '$route': 'initData',
    view: { // 신청구분 각각 클릭시
      deep: true,
      handler() { this.view_all = Object.keys(this.view).every(v=> this.view[v] == true) }
    },
  },
  created() {
    ui = this.$ui;
    this.search = { ...this.search_init }
    this.doSearch()
  },
  mounted() {
     // 공통코드 로드
    ui.codeLoad("CONFIG", code => {
      this.code = code
    });
  },
  methods : {
    onchange_view_all() { // 신청구분 '전체' 클릭시
      Object.keys(this.view).forEach(v=>this.view[v] = this.view_all);
    },
    initData(){ // 현재 메뉴 다시 클릭 시
      this.search = T.deepCopy(this.search_init)
      this.doSearch()
    },
    doSearch() {
      ui.httpGetList(this.list
        , '/proc/N_VIASTAT_SEL_LIST'
        , {
          ...this.search
          , iv_pgsize      : 10000 // TODO : 나중에 변경
          , iv_page        : this.list.pageNo
        },
        ret => {
          this.list.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.list.items      = _.get(ret, "data.rs2", [])

          let viastatclsf = ['VIAFREE', 'CH_OFFICE', 'BOKDARI', 'CH_OWNER', 'CH_CASE','CH_ONLINE']
          let sub_list = []

          viastatclsf.forEach(ret=> {
            sub_list = this.list.items.filter(e => e.viastatclsf == ret)

            this['list_' + ret].items      = sub_list
            this['list_' + ret].totalCount = sub_list.length
            this.view[ret] = sub_list.length > 0
          })

          // 환불 리스트 조회
          ui.httpGetList(this.list_REFUND
          , '/proc/N_VIASTAT_REFUND_SEL_LIST'
          , {
            ...this.search
            , iv_pgsize      : 10000 // TODO : 나중에 변경
            , iv_page        : this.list.pageNo
          },
          ret => {
            this.list_REFUND.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
            this.list_REFUND.items      = _.get(ret, "data.rs2", [])
            this.view['REFUND'] = this.list_REFUND.items.length > 0

            // 미사용 증표 환불 신청 상세내역 숨기기
            this.refundDetailShowYn = false;
          });
        })

        // 과오납 환불 신청 내역
        ui.httpGetList(this.list_BUY_REFUND
        , '/proc/N_REFUND_SEL_LIST'
        , {
          iv_refunddtfr  : this.search.iv_viastatdtfr,
          iv_refunddtto  : this.search.iv_viastatdtto,
          iv_refundclsf  : 'MANUAL',
          iv_rfway       : '',
          iv_rfstat      : '',
          iv_pgsize      : -1,
          iv_page        : this.list.pageNo,
        },
        ret => {
            this.list_BUY_REFUND.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
            this.list_BUY_REFUND.items      = _.get(ret, "data.rs2", [])
            this.view['BUY_REFUND'] = this.list_BUY_REFUND.items.length > 0
        })
    },
    showRefundDetail(item, i) {

      if(this.refundDetailShowYn && this.refundDetailShowNum == i){ // 상세보기 열려있음 & 이전과 같은 항목의 상세보기를 클릭한 경우
        this.refundDetailShowYn = false // 현재 열려있는 [상세보기]를 닫는다.
      }else {
        this.refundDetailShowNum = i
        // 환불 상세내역 조회
        ui.httpGetList(this.list_REFUND_DETAIL
        , '/proc_iv/N_VIASTAT_REFUND_SEL_DTL'
        , item
        , ret => {
          this.list_REFUND_DETAIL.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.list_REFUND_DETAIL.items      = _.get(ret, "data.rs2", [])

          // 미사용 증표 환불 신청 상세내역 보이기
          this.refundDetailShowYn = true;
        });
      }
    },
    callDialog_오사용증표_영수증(item) {
      this.$refs.dialog_receipt.open(item)
    },
    callDialogViaUse(item) { // 증표수정 버튼 클릭
      item.ch_statclsf = 'BC0200'
      item.modal_title = '증표 내역 수정'
      // this.$refs.dialog_usevia.open(item)
      this.callVieModal(item)
    },
     callVieModal(item) {

       var paramItem = null

      // "viaregdt": "20210106",             "new_viaregdt": "20210712",
      // "viaseq  ": 818,                      "new_viaseq": 1325
      // "rcptno  ": "21001003676",            "new_rcptno": "21006015522",
      // new_* 가 있으면 복사
      if (item.new_viaregdt && item.new_viaseq && item.new_rcptno) {
        var newItem = {}
        newItem.viaregdt = item.new_viaregdt
        newItem.viaseq   = item.new_viaseq
        newItem.rcptno   = item.new_rcptno
        paramItem = newItem
      } else {
        paramItem = item
      }

      this.$modal.show(ModalViaFormVue, {
        // 프로퍼티
        menu: 'front_edit',
        param: paramItem,
          // 없음
        // 콜백
        cb_save: this.getData,

      },

      {

        name: "viaForm_" + T.randomAZ(10), // 모달 이름 (unique)
        adaptive: true,

        width: "900",
        height: (Math.min(1000, this.windowHeight -25) ),

        clickToClose: false,

      }, {

      })
    },
  }
}
</script>
<style scoped>
#id_msg:hover .toggleInfo {  margin-top:30px; margin-left:-440px; display: inline-block }
div.lvl_ml label { margin-left: 5px; }
</style>